import { render, staticRenderFns } from "./OrderPayment.vue?vue&type=template&id=87ea1be8&scoped=true"
import script from "./OrderPayment.vue?vue&type=script&lang=js"
export * from "./OrderPayment.vue?vue&type=script&lang=js"
import style0 from "./OrderPayment.vue?vue&type=style&index=0&id=87ea1be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ea1be8",
  null
  
)

export default component.exports